import {Component, ViewChild} from '@angular/core';
import {TextInputComponent} from '../../../shared/forms/text-input/text-input.component';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {PasswordInputComponent} from '../../../shared/forms/password-input/password-input.component';
import {ButtonComponent} from '../../../shared/forms/button/button.component';
import {AuthService} from '../../../core/services/auth.service';
import {Router} from '@angular/router';
import {SpinnerComponent} from '../../../shared/spinner/spinner.component';
import {ErrorMessageComponent} from '../../../shared/forms/error-message/error-message.component';

@Component({
  selector: 'app-login',
  imports: [
    TextInputComponent,
    ReactiveFormsModule,
    PasswordInputComponent,
    ButtonComponent,
    SpinnerComponent,
    ErrorMessageComponent
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginForm: FormGroup;
  errorMessage: string = '';
  @ViewChild('spinner', { static: false }) spinner?: SpinnerComponent;

  constructor(
    private authService: AuthService,
    private router: Router,
    ) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required)
    });
  }

  get emailControl(): FormControl {
    return this.loginForm.get('email') as FormControl;
  }

  get passwordControl(): FormControl {
    return this.loginForm.get('password') as FormControl;
  }

  onSubmit(): void {
    if(this.loginForm.valid){
      this.spinner?.show();
      this.errorMessage = '';
      this.authService.login(this.loginForm.value).subscribe({
        next: () => {
          this.spinner?.hide();
          this.redirectUserToHome();
        },
        error: (error) => {
          this.spinner?.hide();
          this.errorMessage = error || 'Service unavailable';
          console.error('login error', error);
        },
        complete: () => {
          this.spinner?.hide();
        }
      });
    }
  }

  redirectUserToHome(): void {
    const user = this.authService.currentUserValue;
    if(user?.assignments.length === 0) {
      this.router.navigate(['/library/assignments/new']);
    }
    else if(user?.assignments.length === 1 && user?.learningOutcomes.length === 0) {
      this.router.navigate(['/library/assignments', user?.assignments[0].requestKey]);
    }
    else{
      this.router.navigate(['/library']);
    }
  }

}
